// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"559":"61c48096","862":"b86bc54b","983":"82c642ac"}[chunkId] + ".chunk.css";
};